import type { ReactNode } from "react";

export interface CodeProps {
  children: ReactNode;
  className?: string;
}

export function Code({ children, className = "" }: CodeProps) {
  return (
    <code
      className={`mono text-[12px] text-[var(--ink)] bg-[var(--paper-2)] border border-[var(--rule-2)] px-1.5 py-0.5 inline-block break-all ${className}`}
    >
      {children}
    </code>
  );
}

export interface CodeBlockProps {
  children: ReactNode;
  lang?: ReactNode;
  className?: string;
}

export function CodeBlock({ children, lang, className = "" }: CodeBlockProps) {
  return (
    <div className={`bg-[var(--paper-2)] border border-[var(--rule)] ${className}`}>
      {lang && (
        <div className="px-3 py-1.5 border-b border-[var(--rule)] flex items-center justify-between">
          <span className="caption">{lang}</span>
        </div>
      )}
      <pre className="mono text-[12.5px] text-[var(--ink)] p-3 leading-relaxed whitespace-pre-wrap break-words">
        {children}
      </pre>
    </div>
  );
}
